/** 完整权限数据
authority:{btn:'search,view,edit,del,add'}
btn按钮权限：search 搜索按钮，view 查看按钮，edit 编辑按钮，del 删除按钮，add 新增按钮
 */
import i18n from '@/i18n/index'
const t = i18n.global.t


export const magHeadermenu = [{
		path: '/mag/asset/index',
		meta: {
			title: t('mag.router.assetindex'),
			icon: 'Coin'
		},
		children: [{
			path: '/mag/asset/index',
			component: () => import('@/views/mag/view/asset/index.vue'),
			meta: {
				title: t('mag.router.assetindex'),
				pPath: '/mag/asset/index',
				authority: {
					btn: 'add',
					tableBtn: 'view,edit,del'
				},
				name: 'asset'
			},
		}, {
			path: '/mag/asset/view',

			component: () => import('@/views/mag/view/asset/view/index.vue'),
			meta: {
				elmainClass: 'hasGobackMain',
				title: t('mag.router.assetview'),
				pPath: '/mag/asset/index',
				authority: {
					btn: 'add',
					tableBtn: 'edit,del'
				},
				name: 'asset'
			},
		}]
	},
	{
		path: '/mag/device/info',
		meta: {
			title: t('mag.router.deviceinfoTitle'),
			icon: 'Setting',
		},
		children: [{
				path: '/mag/device/info',
				component: () => import('@/views/mag/view/device/info/index.vue'),
				meta: {
					title: t('mag.router.deviceinfo'),
					icon: 'Tickets',
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/info',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,search,add,addMore,addMore1,update,export,dellMore,addLnglatMore,energyReplace',
						tableBtn: 'edit,del',
					},
					name: 'device'
				},
			},
			{
				path: '/mag/device/groupMag',
				component: () => import('@/views/mag/view/device/groupMag/index.vue'),
				meta: {
					title: t('mag.router.devicegroupMag'),
					icon: 'Grid',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/groupMag',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'add',
						tableBtn: 'edit,view,del'
					},
					name: 'device'
				},
			},
			{
				path: '/mag/device/groupMag/view',
				component: () => import('@/views/mag/view/device/groupMag/view/index.vue'),
				meta: {
					title: t('mag.router.devicegroupMagview'),
					icon: 'denggan',
					leftMenuHidden: false,
					leftMenuItemHidden: true,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/groupMag',
					elmainClass: 'hasGobackMain',
					authority: {
						btn: 'searchShowForm,searchHideForm,editDevicesGroup',
						tableBtn: 'editDevicesGroup'
					},
					name: 'device'
				},
			},
			{
				path: '/mag/device/setting',
				component: () => import('@/views/mag/view/device/setting/index.vue'),
				meta: {
					title: t('mag.router.Setting'),
					icon: 'Setting',
					leftMenuHidden: false,

					pPath: '/mag/device/info',
					leftpPath: '/mag/device/setting',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'add,add1',
						tableBtn: 'del2,edit'
					},
					name: 'device'
				},
			},
			{
				path: '/mag/device/energy',
				component: () => import('@/views/mag/view/device/energy/index.vue'),
				meta: {
					title: t('mag.router.energy'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/energy',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,export,add',
					},
					name: 'device'
				},
			},
			{
				path: '/mag/device/activity',
				component: () => import('@/views/mag/view/device/activity/index.vue'),
				meta: {
					title: t('mag.router.activity'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/activity',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,exportExcel,exportWord,dellMore',
						tableBtn: 'del,view'
					},
				},
			},
			{
				path: '/mag/device/sim',
				component: () => import('@/views/mag/view/device/sim/index.vue'),
				meta: {
					title: t('mag.router.sim'),
					icon: 'Cellphone',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/sim',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm',
					},
				},
			},
			{
				path: '/mag/device/scene',
				// component: { render: h => h('router-view') }, 
				component: () => import('@/views/mag/view/device/scene/index.vue'),
				meta: {
					title: t('mag.router.scene'),
					icon: 'film'
				},
				children: [{
						path: '/mag/device/scene/configuration', // 改为相对路径
						component: () => import('@/views/mag/view/device/scene/configuration/index.vue'),
						meta: {
							title: t('mag.router.configuration'),
							leftpPath: '/mag/device/scene/configuration', // 指向自身
							pPath: '/mag/device/info',
							leftMenuHidden: false,
							authority: {
								btn: 'add,dellMore',
								tableBtn: 'del,edit,enabledisable,logout'
							},
						}
					},
					{
						path: '/mag/device/scene/mode', // 改为相对路径
						component: () => import('@/views/mag/view/device/scene/mode/index.vue'),
						meta: {
							title: t('mag.router.mode'),
							leftpPath: '/mag/device/scene/mode', // 指向自身
							pPath: '/mag/device/info',
							leftMenuHidden: false,
							authority: {
								btn: 'add,dellMore',
								tableBtn: 'del,edit,enabledisable'
							},
						}
					},
				]
			},
		]
	},
	{
		path: '/mag/deviceController/index',
		meta: {
			title: t('mag.router.deviceController'),
			icon: 'Document'
		},
		children: [{
				path: '/mag/deviceController/index',

				component: () => import('@/views/mag/view/deviceController/index.vue'),
				meta: {
					elmainClass: 'hasTreeBoxMain',
					title: t('mag.router.deviceController'),
					pPath: '/mag/deviceController/index',
					authority: {
						btn: 'searchShowForm,search,add,lightOption,rd,syncTime,reb,as,SIM,batchReadIPP,batchIPP,setGP,setLdcs,skhl,setHlgg,setJwdpyz,setGJZQ,setHgqzsb,setKglsc,setSbsjzq,setJzqczkg,syncRgj,syncJwd,syncRhlgg,syncHlNb,setHlNb,setHlRm,setHLZR,getHLZR,getSxjlxs,setSxjlxs,rjl,syncDDZR,setDDZR,setBmd,syncBmd,syncHLZR,syncDDQKGGTG,setLxzq,setJzqckg,tgByGroup,setDDQKRBMS,setDDQKGGTG,setWSGD,reset,setGpnum,setTM,readTm,setLxkg,syncJr,syncZr,syncGpnum,syncDDQKJR,setDDQKJR,setWlid,syncWlid,fotaCenterLight,setTgbc,setTgrbms,setTgnb,setTgzr,setTggg,jzqczkg,syncTgnb,syncTggg,syncTgzr,async8DV,async3SI,async3SO,clearCache,dimLightOption,setTglj,save,setTgmrv,setVjl,setIjl,setPjl,readE,readE1,setRm,setDdldggld,readLc,setLc,setLcov,wlsd,setZjid,setCjid,excelDownload,hkSetJwd,HKSetConfigId,hksetChannel,setSxjlxs7,setG,readG,setLkg,readLkg,setRC,readRC,setAic,readAic,set433,read433,readV,setRkg,readRkg,setRTC,readRTC,setRtp,readRtp,setTo,readTo',
						tableBtn:'monitor,location,hksetChannel'
					},
					name: 'control_device'
				},
			},
			{
				path: '/mag/deviceController/view',

				component: () => import('@/views/mag/view/deviceController/view/index.vue'),
				meta: {
					title: '设备数据记录',
					pPath: '/mag/deviceController/index',
					authority: {
						btn: 'searchShowForm',
					},
					// name:'control_device'
				},
			}
		]
	},
	{
		path: '/mag/work/transfer',
		meta: {
			title: t('mag.router.alarmindex'),
			icon: 'Setting',
		},
		children: [{
				path: '/mag/work/transfer',
				component: () => import('@/views/mag/view/work/transfer/index.vue'),
				meta: {
					title: t('mag.router.worktransfer'),
					icon: 'Tickets',
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/transfer',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,add,search,ignore',
						tableBtn: 'del,view',
					},
					name: 'create_work_order'
				},
			}, {
				path: '/mag/work/info',
				component: () => import('@/views/mag/view/work/info/index.vue'),
				meta: {
					title: t('mag.router.workinfo'),
					icon: 'Tickets',
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/info',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,add,search',
						tableBtn: 'del,view',
					},
					name: 'create_work_order'
				},
			},
			{
				path: '/mag/work/view',
				component: () => import('@/views/mag/view/work/view/index.vue'),
				meta: {
					title: "",
					pPath: '/mag/work/view',
					leftMenuItemHidden: true,
					authority: {
						btn: '',
					},
				},
			},
			{
				path: '/mag/work/handle',
				component: () => import('@/views/mag/view/work/handle/index.vue'),
				meta: {
					title: t('mag.router.workHandle'),
					icon: 'Grid',
					leftMenuHidden: false,
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/handle',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: '',
						tableBtn: 'view'
					},
					name: "receive_work_order"
				},
			},
			{
				path: '/mag/work/historyData',
				component: () => import('@/views/mag/view/work/historyData/index.vue'),
				meta: {
					title: t('mag.router.workHistory'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/historyData',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: '',
						tableBtn: 'view'
					},
				},
			},
		]
	},
	{
		path: '/mag/ruleStrategy/info',
		meta: {
			title: t('mag.router.ruleStrategyindex'),
			icon: 'SetUp',
		},
		children: [{
				path: '/mag/ruleStrategy/info',
				component: () => import('@/views/mag/view/ruleStrategy/info/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyInfo'),
					icon: 'Tickets',
					pPath: '/mag/ruleStrategy/info',
					leftpPath: '/mag/ruleStrategy/info',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'add1,add2,add',
						tableBtn: 'del,clone,on,off,cancel,editNew'
					},
					name: 'strategy_rule'
				},
				// children: [{
				// 	path: '/mag/ruleStrategy/info/view', // 改为相对路径
				// 	component: () => import('@/views/mag/view/ruleStrategy/info/view/index.vue'),
				// 	meta: {
				// 		title: '',
				// 		pPath: '/mag/ruleStrategy/info/view',
				// 		leftMenuHidden: true,
				// 		authority: {
				// 			btn: 'searchShowForm,refresh',
				// 			tableBtn: 'retry,message'
				// 		},
				// 	}
				// }]
			},
			{
				path: '/mag/ruleStrategy/group',
				component: () => import('@/views/mag/view/ruleStrategy/group/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyGroup'),
					icon: 'Tickets',
					pPath: '/mag/ruleStrategy/info',
					leftpPath: '/mag/ruleStrategy/group',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'addGroup',
						tableBtn: 'del,cloneNew,editNew'
					},
					name: 'strategy_rule'
				},
			},
			{
				path: '/mag/ruleStrategy/info/view', // 改为相对路径
				component: () => import('@/views/mag/view/ruleStrategy/info/view/index.vue'),
				meta: {
					title: '',
					pPath: '/mag/ruleStrategy/info/view',
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					authority: {
						btn: 'searchShowForm,refresh',
						tableBtn: 'retry,message'
					},
				}
			},
			{
				path: '/mag/ruleStrategy/group/view', // 改为相对路径
				component: () => import('@/views/mag/view/ruleStrategy/group/view/index.vue'),
				meta: {
					title: '',
					pPath: '/mag/ruleStrategy/group/view',
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					authority: {
						btn: 'searchShowForm',
					},
				}
			},
		]
	},
	{
		path: '/mag/log/index',
		meta: {
			title: t('mag.router.logindex'),
			icon: 'Document'
		},
		children: [{
			path: '/mag/log/index',

			component: () => import('@/views/mag/view/log/index.vue'),
			meta: {

				title: t('mag.router.logindex'),
				pPath: '/mag/log/index',
				authority: {
					btn: 'searchShowForm,export,clear,del',
				},
				name: 'log'
			},
		}]
	},
	{
		path: '/mag/user/user',
		meta: {
			title: t('mag.router.user'),
			icon: 'User',
			authorityUser: 'admin'
		},
		children: [{
				path: '/mag/user/user',
				component: () => import('@/views/mag/view/user/user/index.vue'),
				meta: {
					authorityUser: 'admin',
					title: t('mag.router.user'),
					icon: 'Tickets',
					pPath: '/mag/user/user',
					leftpPath: '/mag/user/user',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'search,add,del',
						tableBtn: 'edit,batchDel,enabledisable,logout,authority,pswchange,alarm'
					}
				},
			},
			// {
			// 	path: '/mag/user/media',
			// 	component: () => import('@/views/mag/view/user/media/index.vue'),
			// 	meta: {
			// 		title: t('mag.router.media'),
			// 		icon: 'CameraFilled',
			// 		pPath: '/mag/user/user',
			// 		leftpPath: '/mag/user/media',
			// 		leftMenuHidden: false,
			// 		elmainClass: 'hasTreeBoxMain',
			// 		authority: {
			// 			btn: 'add,dellMore',
			// 			tableBtn: 'edit,del'
			// 		}
			// 	},
			// },
			{
				path: '/mag/user/third',
				component: () => import('@/views/mag/view/user/third/index.vue'),
				meta: {
					title: t('mag.router.third'),
					icon: 'Setting',
					pPath: '/mag/user/user',
					leftpPath: '/mag/user/third',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'add,dellMore',
						tableBtn: 'edit,del'
					}
				},
			},
		]
		// children: [{
		// 	path: '/mag/user/index',

		// 	component: () => import('@/views/mag/view/user/index.vue'),
		// 	meta: {

		// 		title: t('mag.router.user'),
		// 		pPath: '/mag/user/index',
		// 		authorityUser: 'admin',
		// 		authority: {
		// 			btn: 'search,add,del,pswchange',
		// 			tableBtn: 'edit,batchDel,enabledisable,logout,authority'
		// 		}
		// 	},
		// }]
	},
	{
		path: '/mag/deviceSearch/index',
		meta: {
			title: t('mag.router.deviceSearch'),
			icon: 'Search',
			authorityUser: 'admin',
			authorityShow: 'true',
		},
		children: [{
			path: '/mag/deviceSearch/index',

			component: () => import('@/views/mag/view/deviceSearch/index.vue'),
			meta: {

				title: t('mag.router.deviceSearch'),
				pPath: '/mag/deviceSearch/index',
				authorityUser: 'admin',
				authorityShow: 'true',
				authority: {
					btn: 'add,del,pswchange',
					tableBtn: 'edit,batchDel,enabledisable,logout'
				}
			},
		}]
	},
	{
		path: '/mag/deviceTotal/index',
		meta: {
			title: t('mag.router.deviceTotal'),
			icon: 'Postcard',
			authorityUser: 'admin',
			authorityShow: 'true',
		},
		children: [{
			path: '/mag/deviceTotal/index',
			component: () => import('@/views/mag/view/deviceTotal/index.vue'),
			meta: {
				title: t('mag.router.deviceTotal'),
				pPath: '/mag/deviceTotal/index',
				authorityUser: 'admin',
				authorityShow: 'true',
				authority: {
					btn: 'searchShowForm',
				},
			},
		}]
	},
	// {
	//   path: '/mag/communication/index',
	//   meta: {
	//     title: t('mag.router.communication'),
	//     icon: 'Link',
	//     authorityUser: 'admin'
	//     authorityShow:'true'
	//   },
	//   children: [{
	//     path: '/mag/communication/index',

	//     component: () => import('@/views/mag/view/communication/index.vue'),
	//     meta: {

	//       title: t('mag.router.communication'),
	//       pPath: '/mag/communication/index',
	//       authorityUser: 'admin',
	//       authorityShow:'true',
	//       authority: {
	//         btn: 'search,pswchange',
	//         tableBtn: 'edit,batchDel,enabledisable,logout'
	//       }
	//     },
	//   }]
	// },
]